import {booleanAttribute, ChangeDetectionStrategy, Component, Input, numberAttribute} from '@angular/core';
import {SidenavService} from '../../core/services/sidenav.service';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {NgIf} from '@angular/common';
import {slideInOut, slideOutToRight} from './sidenav.animation';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  standalone: true,
  imports: [
    NgIf,
    MatIconModule,
    MatSidenavModule
  ],
  animations: [
    slideInOut,
    slideOutToRight
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
  @Input() title: string = '';
  @Input({transform: booleanAttribute}) closable: boolean = true;
  @Input({transform: numberAttribute}) padding: number = 2;

  constructor(
    public sidenavService: SidenavService,
  ) {
  }

  get animationState() {
    return this.sidenavService.isPushAction ? 'in' : 'out';
  }
}
